<template>
  <div class="password-validation-indicator-wrapper">
    {{ $t('passwordValidationIndicator.before') }}
    <ul>
      <li>
        <i class="icon"
            :class="{ passed: isLongEnough }"
            :aria-label="getAltText(isLongEnough)"
            role="img"></i>
        {{ $t('passwordValidationIndicator.isLongEnough') }}
      </li>
      <li>
        <i class="icon"
            :class="{ passed: hasBigChars && hasSmallChars }"
            :aria-label="getAltText(hasBigChars && hasSmallChars)"
            role="img"></i>
        {{ $t('passwordValidationIndicator.hasBigAndSmallChars') }}
      </li>
      <li>
        <i class="icon"
            :class="{ passed: hasNumbers }"
            :aria-label="getAltText(hasNumbers)"
            role="img"></i>
        {{ $t('passwordValidationIndicator.hasNumbers') }}
      </li>
      <li>
        <i class="icon"
            :class="{ passed: maximumLength }"
            :aria-label="getAltText(maximumLength)"
            role="img"></i>
        {{ $t('passwordValidationIndicator.maximumLength') }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'CsoPasswordValidationIndicator',
  props: {
    password: {
      type: String,
      required: true
    }
  },
  computed: {
    hasNumbers: function () {
      return /\d/.test(this.password)
    },

    hasSmallChars: function () {
      return /[a-z]/.test(this.password)
    },

    hasBigChars: function () {
      return /[A-Z]/.test(this.password)
    },

    isLongEnough: function () {
      return this.password.length > 9
    },
    maximumLength: function () {
      return this.password.length < 36
    }
  },
  methods: {
    getAltText: function (passed) {
      return passed ? 'Grüner Haken' : 'Grauer Haken'
    }
  },
}
</script>
<style lang="scss">
.password-validation-indicator-wrapper {
  font-family: $font-family-regular;
  font-size: 16px;

  ul {
    list-style: none;
    margin: 0;
    padding: 10px 0;

    li {
      font-size: 14px;
      position: relative;
      padding: 0 0 10px 34px;

      i.icon {
        position: absolute;
        left: 0;
        height: 24px;
        width: 24px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        background-color: transparent;
        background-image: url(/static/icons/confirmation-grey.svg);

        &.passed {
          background-image: url(/static/icons/confirmation.svg);
        }
      }
    }
  }
}
</style>
